import React, { useMemo, useState } from 'react'
import Link from 'next/link'
import styles from './icons.module.scss'
import OutsideClickHandler from 'react-outside-click-handler'

export default function Icons ({ dog }) {
  const sharingText = useMemo(
    () =>
      `Check out this puppy in Mawoo Pets! ${dog?.name} - ${
        process.env.NEXT_PUBLIC_ROOT_URL + '/puppy/' + dog?.slug
      }`,
    [dog]
  )

  const [showOptions, setShowOptions] = useState(false)

  const [showCopy, setShowCopy] = useState(false)
  const getLink = () => {
    const el = document.createElement('input')
    el.value = process.env.NEXT_PUBLIC_ROOT_URL + '/puppy/' + dog?.slug
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
    setShowCopy(true)
    return setTimeout(() => {
      setShowCopy(false)
    }, 1000)
  }

  return (
    <div className={styles.container}>
      <button
        className={styles.share}
        onClick={() => setShowOptions((curr) => !curr)}
      >
        <p>Share</p>

        <div className={styles.iconShare} />
      </button>

      {showOptions && (
        <OutsideClickHandler onOutsideClick={() => setShowOptions(false)}>
          <div className={styles.social}>
            <div className={styles.arrow} />

            <h5>Share {dog?.name} with a loved one!</h5>

            <Link
              href={`https://www.facebook.com/sharer/sharer.php?u=${
                process.env.NEXT_PUBLIC_ROOT_URL + '/puppy/' + dog?.slug
              }`}
              target='_blank'
              rel='noreferrer'
            >
              <div className={styles.row}>
                <div className={styles.iconFb} />

                <p>Share to Facebook</p>
              </div>
            </Link>

            <Link
              href={`https://twitter.com/intent/tweet?text=${sharingText}`}
              target='_blank'
              rel='noreferrer'
              className={styles.row}
            >
              <div className={styles.row}>
                <div className={styles.iconTw} />

                <p>Share to X</p>
              </div>
            </Link>

            <Link
              href={`https://www.pinterest.com/pin/create/button/?url=${
                process.env.NEXT_PUBLIC_ROOT_URL + '/puppy/' + dog?.slug
              }&is_video=false&media=${
                process.env.NEXT_PUBLIC_MEDIA_BUCKET +
                dog?.profilePicture?.small
              }&description=${sharingText}`}
            >
              <div className={styles.row}>
                <div className={styles.iconPinterest} />

                <p>Share to Pinterest</p>
              </div>
            </Link>

            <a
              href={`whatsapp://send?text=${sharingText}`}
              data-action='share/whatsapp/share'
              className={styles.row}
            >
              <div className={styles.iconWp} />

              <p>Share to Whatsapp</p>
            </a>

            <Link href={`mailto:someone@gmail.com?body=${sharingText}`}>
              <div className={styles.row}>
                <div className={styles.iconEmail} />

                <p>Share via Email</p>
              </div>
            </Link>

            <div className={styles.row} id='copy_link'>
              <button onClick={getLink} className={styles.row}>
                <div className={styles.iconLink} />

                <p>Copy Link</p>
              </button>

              {showCopy && <div className={styles.tooltipInfo} />}
            </div>

            <button
              className={styles.close}
              onClick={() => setShowOptions(false)}
            >
              Close
            </button>
          </div>
        </OutsideClickHandler>
      )}
    </div>
  )
}
